import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import FaqSection from './components/FaqSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <ContactSection />
        <TopicsSection />
        <CommentsSection />
        <CardsSection />
        <AppSection />
        <CarouselSection />
        <RankingSection />
        <UpdatesSection />
        <IndexSection />
        <FaqSection />
        <FeaturesSection />
        <AboutSection />
        <MediaSection />
      </main>
      <Footer />
    </div>
  );
}